import module from './module.js'
/* Routes */
import './routes/proyecto.js'
import './routes/proyecto/colaboradores.js'
import './routes/proyecto/colaboradores/agregar.js'
import './routes/proyecto/colaboradores/idse.js'
import './routes/proyecto/colaboradores/idse/historial.js'
import './routes/proyecto/colaboradores/idse/exportar.js'
import './routes/proyecto/colaboradores/editar.js'
import './routes/proyecto/colaboradores/editar/salario.js'
import './routes/proyecto/colaboradores/editar/bajas.js'
import './routes/proyecto/colaboradores/editar/altas.js'
import './routes/proyecto/colaboradores/editar/departamento.js'
import './routes/proyecto/colaboradores/editar/migrar.js'
import './routes/proyecto/colaboradores/editar/eliminar.js'
import './routes/proyecto/colaboradores/exportar.js'
import './routes/proyecto/colaboradores/importar.js'
import './routes/proyecto/colaboradores/lista.js'
import './routes/proyecto/configuracion.js'
import './routes/proyecto/configuracion/areas.js'
import './routes/proyecto/configuracion/departamentos.js'
import './routes/proyecto/configuracion/puestos.js'
import './routes/proyecto/colaboradores/creditos.js'
import './routes/proyecto/colaboradores/creditos/infonavit.js'
import './routes/proyecto/colaboradores/creditos/fonacot.js'
import './routes/proyecto/documentos.js'
import './routes/proyecto/documentos/informacionfiscal.js'
import './routes/proyecto/documentos/plantillas.js'
import './routes/proyecto/documentos/plantillas/agregar.js'
import './routes/proyecto/documentos/plantilla/generar.js'
import './routes/proyecto/documentos/plantilla.js'
import './routes/proyecto/documentos/plantilla/contenido.js'
import './routes/proyecto/esquemas.js'
import './routes/proyecto/esquemas/agregar.js'
import './routes/proyecto/filiales.js'
import './routes/proyecto/informacion.js'
import './routes/proyecto/nominas.js'
/* Components */
import './components/component.js'
import './components/colaboradores/component.js'
import './components/colaboradores/agregar/component.js'
import './components/colaboradores/creditos/component.js'
import './components/colaboradores/creditos/fonacot/component.js'
import './components/colaboradores/creditos/fonacot/vincular/component.js'
import './components/colaboradores/creditos/fonacot/lista/component.js'
import './components/colaboradores/creditos/fonacot/confirmar/component.js'
import './components/colaboradores/creditos/infonavit/component.js'
import './components/colaboradores/creditos/infonavit/vincular/component.js'
import './components/colaboradores/creditos/infonavit/lista/component.js'
import './components/colaboradores/creditos/infonavit/confirmar/component.js'
import './components/colaboradores/editar/component.js'
import './components/colaboradores/editar/asociar/colaborador/component.js'
import './components/colaboradores/editar/departamento/component.js'
import './components/colaboradores/editar/departamento/vincular/component.js'
import './components/colaboradores/editar/departamento/confirmar/component.js'
import './components/colaboradores/editar/departamento/lista/component.js'
import './components/colaboradores/editar/salario/confirmar/component.js'
import './components/colaboradores/editar/salario/lista/component.js'
import './components/colaboradores/editar/salario/component.js'
import './components/colaboradores/editar/salario/vincular/component.js'
import './components/colaboradores/editar/bajas/component.js'
import './components/colaboradores/editar/bajas/vincular/component.js'
import './components/colaboradores/editar/bajas/lista/component.js'
import './components/colaboradores/editar/bajas/confirmar/component.js'
import './components/colaboradores/editar/altas/component.js'
import './components/colaboradores/editar/altas/vincular/component.js'
import './components/colaboradores/editar/altas/lista/component.js'
import './components/colaboradores/editar/altas/confirmar/component.js'
import './components/colaboradores/editar/migrar/component.js'
import './components/colaboradores/editar/migrar/item/component.js'
import './components/colaboradores/editar/migrar/confirmar/compoenent.js'
import './components/colaboradores/editar/eliminar/component.js'
import './components/colaboradores/editar/eliminar/lista/component.js'
import './components/colaboradores/editar/eliminar/confirmar/component.js'
import './components/colaboradores/exportar/component.js'
import './components/colaboradores/importar/component.js'
import './components/colaboradores/importar/excel/component.js'
import './components/colaboradores/importar/procesador/component.js'
import './components/colaboradores/importar/procesador/item/component.js'
import './components/colaboradores/lista/component.js'
import './components/colaboradores/idse/component.js'
import './components/colaboradores/idse/exportar/component.js'
import './components/colaboradores/idse/exportar/item/component.js'
import './components/colaboradores/idse/exportar/confirmar/component.js'
import './components/colaboradores/idse/pendientes/component.js'
import './components/colaboradores/idse/historial/component.js'
import './components/colaboradores/idse/historial/item/component.js'
import './components/colaboradores/idse/historial/eliminar/component.js'
import './components/colaboradores/lista/grupo/component.js'
import './components/colaboradores/lista/item/activo/component.js'
import './components/colaboradores/lista/item/inactivo/component.js'
import './components/configuracion/component.js'
import './components/configuracion/af1/component.js'
import './components/configuracion/af1/editar/component.js'
import './components/configuracion/af2/component.js'
import './components/configuracion/af2/editar/component.js'
import './components/configuracion/areas/component.js'
import './components/configuracion/areas/agregar/component.js'
import './components/configuracion/areas/editar/component.js'
import './components/configuracion/areas/eliminar/component.js'
import './components/configuracion/cliente/component.js'
import './components/configuracion/cliente/editar/component.js'
import './components/configuracion/departamentos/component.js'
import './components/configuracion/departamentos/agregar/component.js'
import './components/configuracion/departamentos/editar/component.js'
import './components/configuracion/departamentos/eliminar/component.js'
import './components/configuracion/estado/component.js'
import './components/configuracion/estado/editar/component.js'
import './components/configuracion/zonaSalarial/component.js'
import './components/configuracion/zonaSalarial/editar/component.js'
import './components/configuracion/factor/component.js'
import './components/configuracion/factor/editar/component.js'
import './components/configuracion/timbrado/component.js'
import './components/configuracion/timbrado/editar/component.js'
import './components/configuracion/h2h/component.js'
import './components/configuracion/h2h/editar/component.js'
import './components/configuracion/general/component.js'
import './components/configuracion/general/editar/component.js'
import './components/configuracion/op/component.js'
import './components/configuracion/op/editar/component.js'
import './components/configuracion/op/editar/confirmar/modalidad/component.js'
import './components/configuracion/op/editar/confirmar/modalidad/registrosPatronales/component.js'
import './components/configuracion/puestos/component.js'
import './components/configuracion/puestos/agregar/component.js'
import './components/configuracion/puestos/editar/component.js'
import './components/configuracion/puestos/eliminar/component.js'
import './components/configuracion/sa/component.js'
import './components/configuracion/sa/editar/component.js'
import './components/documentos/component.js'
import './components/documentos/informacionfiscal/component.js'
import './components/documentos/informacionfiscal/periodos/component.js'
import './components/documentos/informacionfiscal/periodos/archivos/component.js'
import './components/documentos/informacionfiscal/periodos/archivos/reciboisr/component.js'
import './components/documentos/informacionfiscal/periodos/archivos/reciboisr/agregar/component.js'
import './components/documentos/informacionfiscal/periodos/archivos/reciboisr/item/component.js'
import './components/documentos/informacionfiscal/periodos/archivos/recibosar/component.js'
import './components/documentos/informacionfiscal/periodos/archivos/recibosar/agregar/component.js'
import './components/documentos/informacionfiscal/periodos/archivos/recibosar/item/component.js'
import './components/documentos/informacionfiscal/periodos/periodo/component.js'
import './components/documentos/plantilla/component.js'
import './components/documentos/plantilla/informacion/component.js'
import './components/documentos/plantilla/contenido/component.js'
import './components/documentos/plantilla/contenido/guardar/component.js'
import './components/documentos/plantillas/component.js'
import './components/documentos/plantillas/agregar/component.js'
import './components/documentos/plantillas/agregar/guardar/component.js'
import './components/documentos/plantilla/generar/component.js'
import './components/documentos/plantilla/generar/formulario/component.js'
import './components/documentos/plantilla/generar/procesar/component.js'
import './components/documentos/plantillas/lista/component.js'
import './components/documentos/plantillas/lista/item/component.js'
import './components/documentos/plantillas/lista/item-archivo/component.js'
import './components/documentos/plantillas/lista/item-carpeta/component.js'
import './components/esquemas/component.js'
import './components/esquemas/agregar/component.js'
import './components/esquemas/editar/component.js'
import './components/esquemas/esquema/component.js'
import './components/esquemas/esquema/comision/component.js'
import './components/esquemas/esquema/comisionistas/component.js'
import './components/esquemas/esquema/comisionistas/agregar/component.js'
import './components/esquemas/esquema/comisionistas/grafica/component.js'
import './components/esquemas/esquema/comisionistas/item/component.js'
import './components/esquemas/esquema/impuestos/component'
import './components/esquemas/esquema/impuestos/agregar/component'
import './components/esquemas/esquema/suministro/component'
import './components/esquemas/item/component.js'
import './components/filiales/component.js'
import './components/filiales/agregar/component.js'
import './components/filiales/filial/component.js'
import './components/filiales/item/component.js'
import './components/informacion/component.js'
import './components/informacion/sa/component.js'
/* Services */
import './services/Proyecto.js'
import './services/Proyecto/Colaboradores.js'
import './services/Proyecto/Colaboradores/Creditos/Fonacot.js'
import './services/Proyecto/Colaboradores2.js'
import './services/Proyecto/Config.js'
import './services/Proyecto/Documentos.js'
import './services/Proyecto/Esquema.js'
import './services/Proyecto/Esquemas.js'
import './services/Proyecto/Esquemas/Comisionistas.js'
import './services/Proyecto/Esquemas/Impuestos'
import './services/Proyecto/Filiales.js'
import './services/Proyecto/Informacion.js'
import './services/Proyecto/Operadoras.js'
import './services/Proyecto/Prorrateo.js'
import './services/Proyecto/Catalogos/Estados.js'
import './services/Proyecto/Catalogos/Departamentos.js'
import './services/Proyecto/Catalogos/Puestos.js'
import './services/Proyecto/Colaboradores/Departamentos.js'
import './services/Proyecto/Colaboradores/Existe.js'
import './services/Proyecto/Colaboradores/IDSE/Archivo.js'
import './services/Proyecto/Colaboradores/IDSE/Clases.js'
import './services/Proyecto/Colaboradores/IDSE/Pendientes.js'
import './services/Proyecto/Colaboradores/IDSE/Movimientos.js'
import './services/Proyecto/Colaboradores/IDSE/Operadora.js'
import './services/Proyecto/Colaboradores/IDSE/Historial.js'
import './services/Proyecto/Colaboradores/IDSE/Historial/Movimiento.js'
import './services/Proyecto/Colaboradores/IDSE/Historial/Movimientos.js'
import './services/Proyecto/Colaboradores/IDSE.js'
import './services/Proyecto/Colaboradores/Puestos.js'
import './services/Proyecto/Colaboradores/Bajas.js'
import './services/Proyecto/Colaboradores/Altas.js'
import './services/Proyecto/Colaboradores/Predeterminado.js'
import './services/Proyecto/Colaboradores/Salarios.js'
import './services/Proyecto/Colaboradores/Siguiente.js'
import './services/Proyecto/Colaboradores/Migrar.js'
import './services/Proyecto/Colaboradores/Migrar/Colaboradores.js'
import './services/Proyecto/Colaboradores/Proyectos.js'
import './services/Proyecto/Colaboradores/RegistrosPatronales.js'
import './services/Proyecto/Configuracion/Af1.js'
import './services/Proyecto/Configuracion/Af2.js'
import './services/Proyecto/Configuracion/Areas.js'
import './services/Proyecto/Configuracion/Cliente.js'
import './services/Proyecto/Configuracion/Departamentos.js'
import './services/Proyecto/Configuracion/Estado.js'
import './services/Proyecto/Configuracion/Factor.js'
import './services/Proyecto/Configuracion/Timbrado.js'
import './services/Proyecto/Configuracion/General.js'
import './services/Proyecto/Configuracion/Op.js'
import './services/Proyecto/Configuracion/Prorrateo.js'
import './services/Proyecto/Configuracion/Puestos.js'
import './services/Proyecto/Configuracion/Sa.js'
import './services/Proyecto/Configuracion/ZonaSalarial.js'
import './services/Proyecto/Configuracion/H2h.js'
import './services/Proyecto/Configuracion/Areas/Area.js'
import './services/Proyecto/Configuracion/Departamentos/Departamento.js'
import './services/Proyecto/Configuracion/Puestos/Puesto.js'
import './services/Proyecto/Colaboradores2/MovimientoIMSS'
import './services/Proyecto/Documentos/Plantilla.js'
import './services/Proyecto/Documentos/Plantilla/Contenido.js'
import './services/Proyecto/Documentos/Plantilla/Configuracion.js'
import './services/Proyecto/Documentos/Plantilla/Configuracion/Colaboradores.js'
import './services/Proyecto/Documentos/Plantilla/Pdf.js'
import './services/Proyecto/Documentos/Plantillas.js'
import './services/Proyecto/Documentos/Plantillas/Configuracion/Etiquetas.js'
import './services/Proyecto/Filiales/Filial.js'
import './services/Proyecto/Reportes/Colaboradores.js'

export default module.name



// WEBPACK FOOTER //
// ./src/fan/proyecto/index.js